import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import { i18n } from "../../../../translate/i18n";
import getMapping from "../../../../repositories/getMapping";
import Loading from "../../../../components/Loading";

export default function DialogListaUser(props) {
  const [inscritos, setInscritos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPag, setTotalPag] = useState(0);
  const [page, setPage] = useState(0);
  const [proximo, setProximo] = useState("proximoOff");
  const [anterior, setAnterior] = useState("anteriorOff");

  const desativeLoading = () => {
    setTimeout(function () {
      setLoading(false);
    }, 300);
  };

  const pesquisa = (e) => {
    setInscritos([]);
    if ((e > 0 && e < totalPag) || e === 0) {
      setPage(e);
      if (props.formados === false) {
        async function listar() {
          await getMapping
            .get(`/inscricao/modulo/${props.initialData.id}?page=${e}`)
            .then((data) => {
              setInscritos(data.content);
              setTotalPag(data.totalPages);
              desativeLoading();
              if (data.content.length > 0) {
                setProximo("");
                setAnterior("");
              } else {
                setProximo("proximoOff");
                setAnterior("anteriorOff");
              }
              if (e === 0) {
                setAnterior("anteriorOff");
              }
              if (e === data.totalPages - 1) {
                setProximo("proximoOff");
              }
            })
            .catch((err) => {
              return;
            });
        }
        listar();
      }
    }
  };

  if (inscritos.length < 1) {
    useState.condicional = false;
  } else {
    useState.condicional = true;
  }

  const TableHead = () => {
    return (
      <thead>
        <tr className="tHead">
          <th>{i18n.t("relatorio.usuario")}</th>
          <th className="text-center">Progresso</th>
          <th className="text-center">Data Inscrição</th>
        </tr>
      </thead>
    );
  };
  const TableBody = () => {
    return useState.condicional ? (
      <>
        <tbody>
          {inscritos.map((item, index) => (
            <tr key={index}>
              <td style={{ flex: "1" }} data-title="Nome : Email">
                {[item.usuarioNome].map((texto, index) => (
                  <span key={index}>
                    {texto} : {item.usuarioEmail}
                  </span>
                ))}
              </td>
              <td data-title="Progresso" className="text-center">
                {[item.progresso].map((texto, index) => (
                  <span key={index}>{texto}%</span>
                ))}
              </td>

              <td data-title="Data" className="text-center">
                {[item.dataInscricao].map((texto, index) => (
                  <span key={index}>{texto}</span>
                ))}
              </td>
            </tr>
          ))}
        </tbody>
        <tr>
          <td
            colSpan="5"
            className="text-center"
            data-title="Options"
            style={{ fontSize: "1.6em" }}
          >
            <i
              className={anterior}
              onClick={() => pesquisa(page - 1)}
              className="mdi mdi-arrow-left-circle icon-size icon-green"
            ></i>
            <span>
              {page + 1}/{totalPag}
            </span>
            <i
              className={proximo}
              onClick={() => pesquisa(page + 1)}
              className="mdi mdi-arrow-right-circle icon-size icon-green"
            ></i>
          </td>
        </tr>
      </>
    ) : (
      <tbody>
        <tr>
          <td
            data-title="Empty Table"
            colSpan="8"
            className="text-left"
            style={{ backgroundColor: "#eff1f9" }}
          >
            {i18n.t("tabela.zeroRegistros")}
          </td>
        </tr>
      </tbody>
    );
  };

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      open={props.open}
      fullWidth={true}
      onClose={() => props.onClose()}
      onEntering={() => pesquisa(0)}
    >
      <div className="header-dialog">
        <div className="header-dialog-title">
          {props.initialData.subTitulo +
            " - '" +
            props.initialData.titulo +
            "'"}
        </div>
        <div className="header-dialog-close" onClick={() => props.onClose()}>
          <CloseIcon />
        </div>
      </div>
      <div className="container-dialog">
        <div
          className="header-dialog-close"
          onClick={() => props.onClose()}
        ></div>
        <table>
          {loading && <Loading title="container-loading-login" />}
          <TableHead />
          <TableBody />
        </table>
      </div>
    </Dialog>
  );
}
